import request from '@/utils/request';
export var getData = function getData(data) {
  return request({
    url: '/api/File/Uploader/png',
    method: 'POST',
    data: data
  });
};